import React from 'react';

import { InspectorFormProvider, LogDataFormGroup } from '../../../components';
import { useTabContext } from '../../../contexts';
import { DocumentInspectorProps, DocumentNode } from '../../../types';
import { TabItemProps } from './TabItem';

export function TabItemInspector({
  value,
  onChange,
}: DocumentInspectorProps<TabItemProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <TabItemInspectorFields value={value} />
    </InspectorFormProvider>
  );
}

function TabItemInspectorFields({
  value,
}: {
  value: DocumentNode<TabItemProps>,
}) {
  const { setLogData } = useTabContext();
  const { children, ...others } = value ?? {};

  return (
    <LogDataFormGroup
      nodeKey={value?.key}
      {...setLogData?.(others)}
    />
  );
}
